import { createReducer } from '../../store.model';

import { ActionType } from './focus-selector.action';
import { defaultState, FocusSelectorState } from './focus-selector.state';
import { FocusSelectorSelectActiveForPerformerRow } from './state/active-for-performer-select.action';
import { focusSelectorSelectActiveForPerformerRowReducer } from './state/active-for-performer-select.reducer';
import { FocusSelectorSortActiveForPerformerGrid } from './state/active-for-performer-sort.action';
import { focusSelectorSortActiveForPerformerGridReducer } from './state/active-for-performer-sort.reducer';
import { FocusSelectorSelectActiveForTeamRow } from './state/active-for-team-select.action';
import { focusSelectorSelectActiveForTeamRowReducer } from './state/active-for-team-select.reducer';
import { FocusSelectorSortActiveForTeamGrid } from './state/active-for-team-sort.action';
import { focusSelectorSortActiveForTeamGridReducer } from './state/active-for-team-sort.reducer';
import { FocusSelectorSelectClosedForPerformerRow } from './state/closed-for-performer-select.action';
import { focusSelectorSelectClosedForPerformerRowReducer } from './state/closed-for-performer-select.reducer';
import { FocusSelectorSortClosedForPerformerGrid } from './state/closed-for-performer-sort.action';
import { focusSelectorSortClosedForPerformerGridReducer } from './state/closed-for-performer-sort.reducer';
import { FocusSelectorSelectClosedForTeamRow } from './state/closed-for-team-select.action';
import { focusSelectorSelectClosedForTeamRowReducer } from './state/closed-for-team-select.reducer';
import { FocusSelectorSortClosedForTeamGrid } from './state/closed-for-team-sort.action';
import { focusSelectorSortClosedForTeamGridReducer } from './state/closed-for-team-sort.reducer';
import { FocusSelectorFilterFocuses } from './state/focus-selection-filter.action';
import { focusSelectorFilterFocusesReducer } from './state/focus-selection-filter.reducer';
import { FocusSelectorSortFocuses } from './state/focus-selection-sort.action';
import { focusSelectorSortFocusesReducer } from './state/focus-selection-sort.reducer';
import {
    FocusSelectorSelectFocus,
    FocusSelectorSelectSubBehaviourRow,
} from './state/focus-selection.action';
import {
    focusSelectorSelectFocusReducer,
    focusSelectorSelectSubBehaviourRowReducer,
} from './state/focus-selection.reducer';
import {
    FocusSelectorInit,
    FocusSelectorInitResult,
} from './state/init.action';
import {
    focusSelectorInitReducer,
    focusSelectorInitResultMainReducer,
} from './state/init.reducer';
import { FocusSelectorSelectGoalRow } from './state/load-goals-select.action';
import { focusSelectorSelectGoalRowReducer } from './state/load-goals-select.reducer';
import { FocusSelectorUpdateSelectedGoal } from './state/load-goals-update.action';
import { focusSelectorUpdateGoalReducer } from './state/load-goals-update.reducer';
import {
    FocusSelectorSelectActiveMetric,
    FocusSelectorSelectMetricRow,
} from './state/metric-selection.action';
import {
    focusSelectorSelectActiveMetricReducer,
    focusSelectorSelectMetricRowReducer,
} from './state/metric-selection.reducer';
import { FocusSelectorSortMetrics } from './state/metric-sort.action';
import { focusSelectorSortMetricsReducer } from './state/metric-sort.reducer';

const { builder, reducer } = createReducer<ActionType, FocusSelectorState>(
    defaultState(),
);

builder.add<FocusSelectorInit>(
    ActionType.COACHING_FOCUS_SELECTOR__INIT,
    focusSelectorInitReducer,
);

builder.add<FocusSelectorInitResult>(
    ActionType.COACHING_FOCUS_SELECTOR__INIT_RESULT,
    focusSelectorInitResultMainReducer,
);

builder.add<FocusSelectorSelectActiveMetric>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_ACTIVE_METRIC,
    focusSelectorSelectActiveMetricReducer,
);

builder.add<FocusSelectorSelectMetricRow>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_METRIC_ROW,
    focusSelectorSelectMetricRowReducer,
);

builder.add<FocusSelectorSortMetrics>(
    ActionType.COACHING_FOCUS_SELECTOR__SORT_METRICS,
    focusSelectorSortMetricsReducer,
);

builder.add<FocusSelectorSelectSubBehaviourRow>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_SUBBEHAVIOUR_ROW,
    focusSelectorSelectSubBehaviourRowReducer,
);

builder.add<FocusSelectorSortFocuses>(
    ActionType.COACHING_FOCUS_SELECTOR__SORT_FOCUSES,
    focusSelectorSortFocusesReducer,
);

builder.add<FocusSelectorFilterFocuses>(
    ActionType.COACHING_FOCUS_SELECTOR__FILTER_FOCUSES,
    focusSelectorFilterFocusesReducer,
);

builder.add<FocusSelectorSelectFocus>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_FOCUS,
    focusSelectorSelectFocusReducer,
);

builder.add<FocusSelectorSelectActiveForPerformerRow>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_ACTIVE_FOR_PERFORMER_ROW,
    focusSelectorSelectActiveForPerformerRowReducer,
);

builder.add<FocusSelectorSortActiveForPerformerGrid>(
    ActionType.COACHING_FOCUS_SELECTOR__SORT_ACTIVE_FOR_PERFORMER_GRID,
    focusSelectorSortActiveForPerformerGridReducer,
);

builder.add<FocusSelectorSelectClosedForPerformerRow>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_CLOSED_FOR_PERFORMER_ROW,
    focusSelectorSelectClosedForPerformerRowReducer,
);

builder.add<FocusSelectorSortClosedForPerformerGrid>(
    ActionType.COACHING_FOCUS_SELECTOR__SORT_CLOSED_FOR_PERFORMER_GRID,
    focusSelectorSortClosedForPerformerGridReducer,
);

builder.add<FocusSelectorSelectActiveForTeamRow>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_ACTIVE_FOR_TEAM_ROW,
    focusSelectorSelectActiveForTeamRowReducer,
);

builder.add<FocusSelectorSortActiveForTeamGrid>(
    ActionType.COACHING_FOCUS_SELECTOR__SORT_ACTIVE_FOR_TEAM_GRID,
    focusSelectorSortActiveForTeamGridReducer,
);

builder.add<FocusSelectorSelectClosedForTeamRow>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_CLOSED_FOR_TEAM_ROW,
    focusSelectorSelectClosedForTeamRowReducer,
);

builder.add<FocusSelectorSortClosedForTeamGrid>(
    ActionType.COACHING_FOCUS_SELECTOR__SORT_CLOSED_FOR_TEAM_GRID,
    focusSelectorSortClosedForTeamGridReducer,
);

builder.add<FocusSelectorSelectGoalRow>(
    ActionType.COACHING_FOCUS_SELECTOR__SELECT_GOAL_ROW,
    focusSelectorSelectGoalRowReducer,
);

builder.add<FocusSelectorUpdateSelectedGoal>(
    ActionType.COACHING_FOCUS_SELECTOR__UPDATE_SELECTED_GOAL,
    focusSelectorUpdateGoalReducer,
);

export const focusSelectorReducer = reducer;
